const MemorySkeleton = ({ variant = 'grid' }) => {
  if (variant === 'albums') {
    return (
      <div className="space-y-3">
        {[0, 1, 2].map((i) => (
          <div key={i} className="memory-card flex animate-pulse overflow-hidden !p-0">
            <div className="h-28 w-24 bg-surface-200 dark:bg-surface-800 sm:h-32 sm:w-28" />
            <div className="flex flex-1 flex-col justify-center gap-2 p-4">
              <div className="h-4 w-2/3 rounded-lg bg-surface-200 dark:bg-surface-800" />
              <div className="h-3 w-1/2 rounded-lg bg-surface-100 dark:bg-surface-800/70" />
              <div className="h-3 w-1/3 rounded-lg bg-surface-100 dark:bg-surface-800/70" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-1 sm:gap-1.5 md:grid-cols-4">
      {Array.from({ length: 9 }).map((_, i) => (
        <div
          key={i}
          className="aspect-square animate-pulse rounded-xl bg-surface-100 dark:bg-surface-800/50"
        />
      ))}
    </div>
  );
};

export default MemorySkeleton;
